type SignupEventParams = {
  ga4EventName?: string
  linkedInConversionID?: number
  plausibleEventName?: string
  posthog?: {
    data?: Record<string, any>
    eventName?: string
    identify?: boolean
  }
  uetEventName?: string
}

export const captureEvents = ({
  ga4EventName,
  linkedInConversionID = 4278073,
  plausibleEventName = 'Platform Signup',
  posthog = {
    identify: false
  },
  uetEventName = 'signup'
}: SignupEventParams) => {
  // Posthog events
  if (window.posthog && posthog.eventName && posthog.data) {
    window.posthog.capture(posthog.eventName, {
      ...posthog.data
    })
  }

  if (window.posthog && posthog.data?.email && posthog.identify) {
    window.posthog.identify(posthog.data.email, {
      email: `${posthog.data.email}`
    })
  }

  // Plausible event
  if (window.plausible && plausibleEventName) {
    window.plausible(plausibleEventName)
  }

  // UET event
  if (uetEventName) {
    window.uetq = window.uetq || []
    window.uetq.push('event', uetEventName, {})
  }

  // Lintrk event
  if (window.lintrk && linkedInConversionID) {
    window.lintrk('track', { linkedInConversionID })
  } else {
    const img = new Image(1, 1)
    img.src = `https://dc.ads.linkedin.com/collect/?pid=${linkedInConversionID}&fmt=gif`
  }

  // GA4 event
  if (window.dataLayer && ga4EventName) {
    window.dataLayer.push({ event: ga4EventName })
  }
}
